<template>
  <div class="page project-detail-page">
    <div class="top-image">
      <img :src="detailObj.topImage" alt="">
    </div>

    <div class="section section1">
      <h1 class="section-title">{{ detailObj.sectionOne.title }}</h1>
      <p class="section-desc">{{ detailObj.sectionOne.desc }}</p>
      <div class="section-content">
        <div class="img-container"><img :src="detailObj.sectionOne.image" alt=""></div>
        <ul>
          <li v-for="(item, index) in detailObj.sectionOne.listData" :key="index">
            <div class="index">{{ '0' + (index + 1) }}</div>
            <div style="flex: 1;">
              <h2 class="title">{{ item.title }}</h2>
              <p class="content">{{ item.content }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="section section2">
      <h1 class="section-title">{{ detailObj.sectionTwo.title }}</h1>
      <p class="section-desc">{{ detailObj.sectionTwo.desc }}</p>

      <!--      手机-->
      <div class="section-content" v-if="projectType === 'mobile'">
        <ul class="logos">
          <li v-for="(value, key, index) in detailObj.sectionTwo.listData" :key="key"
              :class="{ 'hover-li': currentIndex === index, 'other-li':  currentIndex !== index && currentIndex !== -1 }"
              @mouseleave="mouseLeave(value)" @mouseenter="mouseEnter(value, index)">
            <svg-icon class="mobile-logo" :icon-class="value.logo"/>
          </li>
        </ul>
        <Transition name="fade">
          <div class="video-container" v-if="videoUrl !== ''">
            <video :src="videoUrl" autoplay muted></video>
          </div>
          <ul class="mobiles-container" v-else>
            <li v-for="(value, key) in detailObj.sectionTwo.listData" :key="key" class="mobiles">
              <!--          <div class="mobile-logo">{{item.logo}}</div>-->
              <div class="mobile-item" v-for="(item, index) in value.mobileList" :key="index">
                <div class="mobile-img"><img :src="item.image" alt=""></div>
                <div class="mobile-name">{{ item.name }}</div>
              </div>
            </li>
          </ul>
        </Transition>
      </div>
      <!--      列车-->
      <div class="section-content rail-img" v-else-if="projectType === 'highSpeedRail'">
        <img src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667439409602high-speed rail-summary-picture.jpg"
             alt="">
      </div>

      <!--      其它-->
      <div class="cr-list-container" v-else>
        <div class="mask"></div>
        <cr-list v-if="crDataList.length" :cr-list="crDataList"/>
        <div v-if="!finished" class="custom-button" @click="getCulturalRelicList">查看更多</div>
        <div v-else class="finished">没有更多了</div>
      </div>
    </div>

    <!--    仅手机-->
    <div class="section section3" v-if="projectType === 'mobile'">
      <h1 class="section-title">{{ detailObj.sectionThree.title }}</h1>
      <p class="section-desc">{{ detailObj.sectionThree.desc }}</p>
      <div class="section-content">
        <custom-swiper :swiper-list="detailObj.sectionThree.listData"/>
      </div>
    </div>

    <!--    仅高铁-->
    <div class="section section3" v-if="projectType === 'highSpeedRail'">
      <h1 class="section-title">{{ detailObj.sectionThree.title }}</h1>
      <p class="section-desc">{{ detailObj.sectionThree.desc }}</p>
      <div class="section-content rail-card-container">
        <div class="rail-card">
          <img :src="detailObj.sectionThree.rail.image" alt=""/>
          <div class="text-area">
            <span class="rail-name">{{ detailObj.sectionThree.rail.name }}</span>
            <span class="rail-introduce multiple-ellipsis">{{ detailObj.sectionThree.rail.content }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="section section4">
      <ul>
        <template v-for="(item, index) in projectCardList" :key="index">
          <li v-if="item.routePath !== route.fullPath" @click="router.push(item.routePath)">
            <img :src="item.bgImage" alt="">
          </li>
          <!--          <li v-if="item.routePath !== route.fullPath" :style="{ backgroundImage: `url(${item.bgImage})` }">-->
          <!--            <div class="name">{{item.name}}</div>-->
          <!--            <div class="custom-button" @click="router.push(item.routePath)">点击查看</div>-->
          <!--          </li>-->
        </template>
      </ul>
    </div>

    <!--    家具、服装、陶瓷-->
    <div class="section section5"
         v-if="projectType === 'furniture' || projectType === 'clothing' || projectType === 'pottery'">
      <h1 class="section-title">{{ detailObj.sectionFive.title }}</h1>
      <p class="section-desc">{{ detailObj.sectionFive.desc }}</p>
      <ul>
        <li v-for="(item, index) in detailObj.sectionFive.listData" :key="index">
          <div class="square-container">
            <img :src="item.image" alt="">
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="author">{{ item.author }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import mockData from '@/mock/project'
import { listCulturalRelic } from '@/apis'

import CrList from '@/components/CrList/index'
import CustomSwiper from '@/components/CustomSwiper/index'
import SvgIcon from '@/components/SvgIcon'

const route = useRoute()
const router = useRouter()

const projectType = ref('')
const detailObj = ref({})

const crDataList = ref([])
const finished = ref(false)

const categoryIds = {
  furniture: 'f9aa1a29f59f434580ec1313489fd35d',
  pottery: '44008a98170f4584b7a72674c50f514d',
  clothing: '187480364c194e1d8faac804a077da2a'
}
const queryParams = {
  categoryId: '',
  page: 1,
  pageSize: 12
}

function getCulturalRelicList () {
  listCulturalRelic(queryParams).then(res => {
    const data = res.data?.map(item => {
      item = {
        ...item,
        properties: []
      }
      item.type && item.properties.push(item.type)
      item.period && item.properties.push(item.period)
      return item
    })
    crDataList.value.push(...data)
    queryParams.page += 1
    if (data.length < queryParams.pageSize) {
      finished.value = true
    }
  })
}

watch(route, () => {
  projectType.value = route.params.type
  detailObj.value = mockData[projectType.value]
  if (categoryIds[projectType.value] !== undefined) {
    queryParams.categoryId = categoryIds[projectType.value]
    queryParams.page = 1
    crDataList.value = []
    getCulturalRelicList()
  }
}, {
  immediate: true,
  deep: true
})

const projectCardList = ref([
  {
    name: '陶瓷专题',
    bgImage: require('@/assets/images/project-card1.png'),
    routePath: '/projectDetail/pottery'
  },
  {
    name: '家具专题',
    bgImage: require('@/assets/images/project-card2.png'),
    routePath: '/projectDetail/furniture'
  },
  {
    name: '服装专题',
    bgImage: require('@/assets/images/project-card3.png'),
    routePath: '/projectDetail/clothing'
  },
  {
    name: '手机专题',
    bgImage: require('@/assets/images/project-card4.png'),
    routePath: '/projectDetail/mobile'
  },
  {
    name: '高铁专题',
    bgImage: require('@/assets/images/project-card5.png'),
    routePath: '/projectDetail/highSpeedRail'
  }
])

// 中国手机图集
const videoUrl = ref('')
const currentIndex = ref(-1)

function mouseLeave (data) {
  videoUrl.value = ''
  currentIndex.value = -1
}

function mouseEnter (data, index) {
  videoUrl.value = data.videoUrl
  currentIndex.value = index
}
</script>

<style lang="scss" scoped>
.project-detail-page {
  padding-top: 90px;
}

.top-image img {
  width: 100%;
  height: 508px;
}

.section1 {
  padding-top: 177px;

  .section-content {
    padding: 0 300px;
    display: flex;
  }

  .img-container {
    flex: 1;
    padding: 67px 126px;
    display: flex;
    align-items: center;

    img {
      width: 100%;
    }
  }

  ul {
    flex-basis: 397px;

    li {
      margin-bottom: 53px;
      display: flex;
    }

    .index {
      font-size: 26px;
      font-weight: 500;
      line-height: 46px;
      color: #9B9B9B;
      margin-right: 45px;
    }

    .title {
      font-size: 32px;
      font-weight: 700;
      line-height: 46px;
      color: #3D3D3D;
      margin-bottom: 13px;
    }

    .content {
      font-size: 16px;
      line-height: 30px;
      color: #6D6D6D;
    }
  }
}

.section2 {
  .logos, .mobiles-container, .video-container {
    padding: 0 214px;
  }

  // 高铁
  .rail-img {
    padding: 0 212px;

    img {
      width: 100%;
    }
  }

  // 手机
  .logos {
    display: flex;
    margin-bottom: 109px;

    li {
      width: 20%;
      display: flex;
      justify-content: center;
      transition: all 0.3s;

      &.hover-li {
        color: #a53620;
        transform: scale(1.2);
      }

      &.other-li {
        color: #c7c7c7;
        transform: scale(0.6);
      }
    }

    .mobile-logo {
      height: 38px;
      cursor: pointer;
    }
  }

  .mobiles-container {
    display: flex;
    flex-wrap: wrap;

    .mobiles {
      width: 20%;
      padding: 0 34px;
      box-sizing: border-box;
    }

    .mobile-item {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      margin-bottom: 86px;

      .mobile-img {
        margin-bottom: 46px;
        height: 262px;

        img {
          height: 100%;
        }
      }

      .mobile-name {
        font-size: 20px;
        line-height: 29px;
      }
    }
  }

  .video-container video {
    height: 846px;
    width: 100%;
  }

  // 家具、服装、陶瓷
  .cr-list-container {
    padding: 0 86px;
    margin-bottom: 130px;
    position: relative;

    .mask {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -2px;
      z-index: 1;
      height: 239px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%, #FFFFFF 100%);
    }

    .custom-button, .finished {
      position: absolute;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
    }

    .custom-button {
      width: 161px;
      height: 54px;
      border-radius: 32px;
      border: 1.5px solid #000;
      font-size: 24px;
      font-weight: 600;
      line-height: 50px;
      text-align: center;
      font-family: 'NotoSerifSC', system-ui;
    }

    .finished {
      font-size: 24px;
      line-height: 52px;
      color: #575757;
    }
  }
}

//高铁和手机独有的模块
.section3 {
  .section-content {
    padding: 0 166px;

    .custom-swiper {
      height: 761px;
      border-radius: 10px;

      :deep(.swiper-slide img) {
        height: 761px;
      }
    }
  }

  .rail-card-container {
    padding: 0 166px;

    .rail-card {
      width: 100%;
      height: 761px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
    }

    .rail-card img {
      width: 100%;
      height: 100%;
    }

    .text-area {
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: 0;
      right: 0;
      height: 176px;
      background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
      padding: 0 61px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .rail-name {
        font-size: 36px;
        font-weight: 600;
        line-height: 52px;
        color: white;
        font-family: 'NotoSerifSC', system-ui;
      }

      .rail-introduce {
        font-size: 24px;
        font-weight: 400;
        line-height: 35px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}

.section4 {
  ul {
    padding: 0 300px;
    display: flex;
  }

  li {
    width: 315px;
    height: 108px;
    border-radius: 5px;
    //padding: 34px 0 0 42px;
    box-sizing: border-box;
    color: white;
    margin-right: 20px;
    background-size: 100% 100%;
    cursor: pointer;
    &:last-of-type {
      margin-right: 0;
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }

    .name {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 4px;
    }

    .custom-button {
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.4);
    }
  }
}

.section5 {
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0 106px;
  }

  li {
    width: 24%;
    margin-right: 1%;
    margin-bottom: 20px;

    &:nth-of-type(4n) {
      margin-right: 0;
    }

    .name {
      font-size: 20px;
      font-weight: 600;
      line-height: 29px;
      font-family: 'NotoSerifSC', system-ui;
      margin-top: 15px;
    }

    .author {
      font-size: 16px;
      font-weight: 300;
      line-height: 23px;
      font-family: 'NotoSerifSC', system-ui;
    }
  }
}
</style>
